<template lang="pug">
//-vue-transmit(ref="uploader", :options="options", :adapter-options="adapterOptions", @success="onUploadSuccess")
  template(slot="files", slot-scope="props")
    .attachments(v-for="(file, i) in props.files", :key="file.id")
      .attachment {{ file.name }}
div.file-upload(:class="size")
  .file-upload-trigger(@click="clickUploadTrigger")
    slot(:status="status")
  .error(v-if="error") {{ error }}
  div.file-upload-input
    input(
      type="file",
      id="files",
      ref="hiddenFileInput",
      multiple,
      :accept="accept",
      @change="handleFilesUpload"
    )
</template>

<script>

export default {
  name: 'FormUpload',
  components: {
  },
  props: {
    size: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      default: '.gif,.jpg,.png,.jpeg,.webp'
    },
    endpoint: {
      type: String,
      default: 'upload'
    }
  },
  data() {
    return {
      files: [],
      status: 'initial',
      error: null
    }
  },
  mounted() {
    //['added-file', 'processing', 'sending', 'success', 'error'].forEach(this.listen)
  },
  computed: {
    endpointUrl () {
      return this.endpoint === 'upload' ? '/company/upload' : '/company/attachment'
    }
  },
  methods: {
    clickUploadTrigger() {
      this.$refs.hiddenFileInput.click()
    },
    handleFilesUpload() {
      let that = this
      let uploadedFiles = this.$refs.hiddenFileInput.files;
      /*
        Adds the uploaded file to the files array
      */
      for( var i = 0; i < uploadedFiles.length; i++ ){
        this.files.push( uploadedFiles[i] )
      }
      //console.log(this.files)

      /*
      Initialize the form data
      */
      let formData = new FormData()
      /*
        Iterate over any file sent over appending the files
        to the form data.
      */
      for( var i = 0; i < this.files.length; i++ ){
        let file = this.files[i]
        formData.append('files[' + i + ']', file)
      }
      /*
        Make the request to the POST /select-files URL
      */
      let options = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      //api.postFileUpload(formData,)
      this.error = null
      this.$emit('uploading')
      console.log(this.endpointUrl, formData, options)
      this.$axios.post(this.endpointUrl, formData, options)
      .then(result => {
        console.log(result)
        that.$emit('uploaded', result.data)
        // reset
        that.error = null
        that.files = []
      })
      .catch(function(error){
        console.log(error.response.data.error)
        that.error = error.response.data.error
        that.status = 'initial'
        that.$emit('errored')
        that.files = []
      })
    },
  }
}
</script>

<style scoped lang="stylus">

.file-upload
  cursor pointer
  display inline-block
  &.full
    display block
.file-upload-input
  position absolute
  top 0
  left 0
  width 0
  height 0
  visibility hidden
</style>
